import React from "react";
import clsx from "clsx";
import BookingFlowTotal from "../BookingFlow/BookingFlowTotal";
import DateHelper from "../DateHelper/DateHelper";

class PortalReservationPresenterSummaryTab extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'summary',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="summary">
        <div className="row">
          <div className="col-md-12">
            <div className="BookingFlow">
              <div className="BookingTotal" style={{marginTop: '15px'}}>
                <BookingFlowTotal {...this.props.reservation} {...this.props} {...this.state} show_due_today={false} date_format={DateHelper.rubyToDateFNS(this.props.date_format)} portal={true} />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <a href="#" onClick={this.props.onToggleTerms} style={{textDecoration: 'underline', fontWeight: 'bold', fontSize: '12px'}}>{I18n.t('view')} {I18n.t('terms_and_conditions')}</a>
          </div>
        </div>
      </div>
    )
  }
}

export default PortalReservationPresenterSummaryTab
